
import * as List from "list.js";
import { debounce } from "throttle-debounce";
import Svgs from "../layout/svgs";
import Modal from "../layout/modal";

const SearchResults = (target) => {

  const el = {
    wrapper: target,
    form: target.querySelector(".search-results__form"),
    input: target.querySelector("[data-search-input]"),
    phrase: target.querySelector("[data-search-phrase]"),
    phraseFor: target.querySelector("[data-search-phrase-for]"),
    count: {
      events: target.querySelector("[data-search-count-events]"),
      magazines: target.querySelector("[data-search-count-magazines]"),
      news: target.querySelector("[data-search-count-news]"),
      pages: target.querySelector("[data-search-count-pages]"),
      total: target.querySelector("[data-search-count-total]"),
      videos: target.querySelector("[data-search-count-videos]"),
      staff: target.querySelector("[data-search-count-staff]"),
    },
    results: {
      events: target.querySelector("[data-search-results-events]"),
      magazines: target.querySelector("[data-search-results-magazines]"),
      news: target.querySelector("[data-search-results-news]"),
      pages: target.querySelector("[data-search-results-pages]"),
      videos: target.querySelector("[data-search-results-videos]"),
      staff: target.querySelector("[data-search-results-staff]"),
    },
  };

  const searchParams = new URLSearchParams(window.location.search);
  let loaderTimeout = null;

  const method = {

    init: () => {
      el.input.value = searchParams.get("q");

      el.input.addEventListener("keyup", (event) => {
        if (event.target.value.length > 1) {
          if (loaderTimeout) clearTimeout(loaderTimeout);
          el.wrapper.classList.add("search-results--loading");
        }
      });
      el.input.addEventListener("keyup", debounce(500, method.performSearch));
      el.form.addEventListener("submit", event => event.preventDefault());

      method.performSearch({
        target: {
          value: searchParams && searchParams.get("q") ? searchParams.get("q") : "",
        },
      });
    },

    performSearch: (event) => {
      if (loaderTimeout) clearTimeout(loaderTimeout);
      el.wrapper.classList.add("search-results--loading");
      searchParams.set("q", event.target.value);
      const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${searchParams.toString()}`;
      window.history.pushState({ path: newUrl }, "", newUrl);
      const formData = new FormData(el.form);

      if (event.target.value.length > 1) {
        fetch(el.form.getAttribute("action"), {
          method: el.form.getAttribute("method"),
          body: formData,
        })
          .then(response => response.json())
          .then((data) => {
            // console.log("Success:", data.result);
            method.renderSearchResults(data.result, data.result.count, event.target.value);
            loaderTimeout = setTimeout(() => {
              el.wrapper.classList.remove("search-results--loading");
            }, 700);
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.log("Something went wrong!", err);
          });

      } else {
        method.resetSearchResults(0, event.target.value);
        if (loaderTimeout) clearTimeout(loaderTimeout);
        el.wrapper.classList.remove("search-results--loading");
      }
    },

    renderSearchResults: (results, count, phrase) => {
      const res = results && results.categorizedResults;

      method.resetSearchResults(count, phrase);

      if (res) {

        if (res.events) {
        
          method.renderItems(res.events, res.eventsCount, el.results.events, el.count.events);
        } else {
          el.count.events.innerHTML = 0;
        }

        if (res.magazines) {
          method.renderItems(res.magazines, res.magazinesCount, el.results.magazines, el.count.magazines);
        } else {
          el.count.magazines.innerHTML = 0;
        }

        if (res.news) {
          method.renderItems(res.news, res.newsCount, el.results.news, el.count.news);
        } else {
          el.count.news.innerHTML = 0;
        }

        if (res.pages) {
          method.renderItems(res.pages, res.pagesCount, el.results.pages, el.count.pages);
        } else {
          el.count.pages.innerHTML = 0;
        }

        if (res.videos) {
          method.renderItems(res.videos, res.videosCount, el.results.videos, el.count.videos);
        } else {
          el.count.videos.innerHTML = 0;
        }

        if (res.staff) {
          method.renderItems(res.staff, res.staffCount, el.results.staff, el.count.staff);
        } else {
          el.count.staff.innerHTML = 0;
        }
      }
    },

    resetSearchResults: (count, phrase) => {
      const els = [
        el.results.events,
        el.results.magazines,
        el.results.news,
        el.results.pages,
        el.results.videos,
        el.results.staff,
      ];

      const counters = [
        el.count.events,
        el.count.magazines,
        el.count.news,
        el.count.pages,
        el.count.videos,
        el.count.staff,
      ];

      el.count.total.innerHTML = count;
      el.phrase.innerHTML = phrase;
      el.phraseFor.style.display = !phrase ? "none" : "inline";

      els.forEach((element) => {
        if (element) {
          // eslint-disable-next-line no-param-reassign
          element.innerHTML = "";
          // eslint-disable-next-line no-param-reassign
          element.nextElementSibling.firstElementChild.innerHTML = "";
        }
      });

      counters.forEach((counter) => {
        if (counter) {
          // eslint-disable-next-line no-param-reassign
          counter.innerHTML = "0";
        }
      });
    },

    renderItems: (results, count, elResults, elCount) => {

      if (!elResults || !elCount) return;

      const isStaffItem = elResults.hasAttribute("data-search-results-staff");
      const isVideoItem = elResults.hasAttribute("data-search-results-videos");

      // eslint-disable-next-line no-param-reassign
      elCount.innerHTML = count;
      results.forEach((result, index) => {
        const li = document.createElement("li");
        li.setAttribute("data-nr", index + 1);
        li.innerHTML = isStaffItem ? `
          <a href="mailto:${result.email}" class="custom search-results__link search-results__link--staff">
            <span class="search-results__icon" style="background-image: url('${result.image}')"></span>
            <span class="search-results__text">
              <span>${result.name}</span>
              <span>${result.position}</span>
              <span>${result.email}</span>
            </span>
          </a>
          ` : isVideoItem ? `
          <button class="search-results__link search-results__link--video" data-modal-open="modal" data-modal-yt-id="${result.url}">
            <span class="search-results__icon" style="background-image: url('${result.image}?width=140&height=140&mode=crop')"></span>
            <span class="search-results__text">
              <span>${result.name}</span>
              <span>${result.date}</span>
            </span>
          </button>
          ` : `
          <a href="${result.url}" class="custom search-results__link">
            <span class="search-results__icon">${Svgs.icons.file}</span>
            <span class="search-results__text">
              <span>${result.name}</span>
              <span>${result.url}</span>
            </span>
          </a>
          `;

        elResults.appendChild(li);
      });

      //* Video results are modals
      Modal.init();

      if (count > 15) {
        // eslint-disable-next-line no-new
        const list = new List(elResults.parentElement, {
          listClass: "search-results__results",
          page: 15,
          pagination: [{
            paginationClass: "list-js-pagination",
            innerWindow: 2,
            outerWindow: 2,
          }],
        });

        list.on("updated", () => {
          setTimeout(() => {
            method.customizePagination(elResults.nextElementSibling);
          }, 0);

          window.scrollTo({
            behavior: "smooth",
            top: 0,
            left: 0,
          });
        });

        method.customizePagination(elResults.nextElementSibling);
      }
    },

    customizePagination: (pagination) => {
      const links = pagination.querySelectorAll("a");
      const active = pagination.querySelector(".active");
      const disabled = pagination.querySelectorAll(".disabled");

      links.forEach((link) => {
        link.classList.add("custom");
        link.classList.add("pagination__button");
      });

      disabled.forEach((link) => {
        link.firstElementChild.classList.add("pagination__button--dots");
        link.classList.remove("disabled");
      });

      active.firstElementChild.classList.add("pagination__button--selected");
      active.classList.remove("active");
    },
  };

  method.init();
};

export default SearchResults;
